import { Box } from "arkh";
import React, { SetStateAction, useCallback } from "react";

import { graphql, useFragment } from "react-relay";
import { useSizeClass } from "../../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";
import {
  TeamSelectList,
  TeamSelectListWholeStoreOption,
} from "widgets/src/TeamSelectList";
import { WAFakeHeader } from "../WidgetAdd/WAFakeHeader";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";
import { WidgetOverviewSettings_Store$key } from "./__generated__/WidgetOverviewSettings_Store.graphql";
import { useModalInsets } from "../../../../components/mobile/useModalInsets";

type Props = {
  teamIds: string[];
  setTeamIds(_: SetStateAction<string[]>): void;
  store: WidgetOverviewSettings_Store$key;
};

export function WidgetOverviewSettings(props: Props) {
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  const data = useFragment(
    graphql`
      fragment WidgetOverviewSettings_Store on Store {
        publicTeams {
          id
          ...TeamSelectList_Team
        }
      }
    `,
    props.store
  );

  const onItemPress = useCallback(
    (itemId: string, selected: boolean) => {
      if (selected) {
        props.setTeamIds((ids) => ids.filter((id) => id !== itemId));
      } else if (data.publicTeams.length - 1 === props.teamIds.length) {
        props.setTeamIds([]);
      } else {
        props.setTeamIds((ids) => [...ids, itemId]);
      }
    },
    [data.publicTeams.length, props]
  );

  const intl_tokens = useIntlTokens();
  const insets = useModalInsets();
  return (
    <Box style={{ flex: 1 }} color="surface-background-light">
      {!isCompact ? <WAFakeHeader title={intl_tokens.SelectTeams} /> : null}
      <TeamSelectList
        contentBox={{ spaceTop: "medium" }}
        insets={insets}
        teams={data.publicTeams}
        selected={props.teamIds}
        ListHeaderComponent={
          <TeamSelectListWholeStoreOption
            onSelect={() => props.setTeamIds([])}
            selected={props.teamIds.length === 0}
          />
        }
        onItemPress={onItemPress}
      />
    </Box>
  );
}
